import { PageHeader } from '@egw/components'
import { CUSTOMER_SERVICE_PHONE_NUMBER, CUSTOMER_SERVICE_PHONE_NUMBER_DISPLAY, WEALTH_ROUTES } from '@egw/constants'
import { Trans, useTranslation } from '@egw/i18n'
import { type FC } from 'react'

export const RolloverIRAInfoPage: FC = () => {
  const { t } = useTranslation('features-transfer')

  return (
    <>
      <PageHeader
        title={t('rollover_ira.title')}
        subtitle={t('transfer.title')}
        backLinkUrl={WEALTH_ROUTES.TRANSFER_ROLLOVER_IRA.backPath}
        className="!pb-0"
      />
      <div className="egw-container flex flex-col gap-sm !pt-2xl">
        <p className="typo-primary-base-regular text-text-body">{t('rollover_ira.description_1')}</p>
        <p className="typo-primary-base-regular text-text-body">
          <Trans t={t} i18nKey="rollover_ira.description_2">
            <a
              href={`tel:${CUSTOMER_SERVICE_PHONE_NUMBER}`}
              title={t('rollover_ira.call')}
              rel="noopener"
              className="text-sky-500 hover:underline hover:cursor-pointer typo-primary-base-semibold"
            >
              {CUSTOMER_SERVICE_PHONE_NUMBER_DISPLAY}
            </a>
          </Trans>
        </p>
      </div>
    </>
  )
}
